import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=01f81886&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports